import React from "react";
import Profile from "../images/naukriPP.jpeg";

export default function ProfileName() {
  return (
    <div className='w-fit h-full card rounded-box place-items-center text-center space-y-2 p-4'>
      <div className='avatar'>
        <div className='w-48 rounded-full ring ring-[#ffffff3c] ring-offset-base-100 ring-offset-1'>
          <img src={Profile} />
        </div>
      </div>
      <span className='text-3xl'>Abhishek Sharma</span>
      <cite className='lg:text-lg text-md text-[#a6a1a1]'>
        <q>Education is not preparation for life, <br/>
        &nbsp;Education is life itself</q>
        <div className="w-full text-right">
        <p>- John Dewey</p>
        </div>
      </cite>
    </div>
  );
}
